module.exports = __webpack_public_path__ + "img/iso1328-1-2013_figE02_runout-from-pitch-measurement.187eab0e.png";